import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
const FooterOfKas = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            d_koyparadandolar,
            d_koyparadandinar,
            d_koyparadanRRR,
            d_koyparakomdolar,
            d_koyparakomdinar,
            d_koyparakomRRR
          } = value;
          return (
            <>
              {/* second row */}
              <br />
              <div className="row">
                <div className="col-lg-12 col-12">
                  <div className="row ">
                    <div className="col-lg-2  col-3">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={d_koyparadandolar}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-3 col-3">
                      <h3 className="text-warning tc ">$کۆی پارەدان</h3>
                    </div>

                    <div className="col-lg-2 col-3">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={d_koyparakomdolar}
                          prefix={"$"}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-2 col-3">
                      <h3 className="text-warning tc">مافی کۆمپانا</h3>
                    </div>

                    <div className="col-lg-2 col-2"></div>
                    <div className="col-lg-2 col-2"></div>
                  </div>
                </div>
              </div>

              {/* third row */}
              <div className="row">
                <div className="col-lg-12 col-12">
                  <div className="row ">
                    <div className="col-lg-2 col-2 ">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={d_koyparadandinar}
                          className=" f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-3 col-4">
                      <h3 className="text-warning tc">IDکۆی پارەدان</h3>
                    </div>

                    <div className="col-lg-2 col-3">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={d_koyparakomdinar}
                          prefix={"ID"}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>

                    <div className="col-lg-1 col-3"></div>

                    <div className="col-lg-2 col-3"></div>

                    <div className="col-lg-1 col-3"></div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12 col-12">
                  <div className="row ">
                    <div className="col-lg-2 col-2 ">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={d_koyparadanRRR}
                          className=" f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-3 col-4">
                      <h3 className="text-warning tc">Rکۆی پارەدان</h3>
                    </div>

                    <div className="col-lg-2 col-3">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={d_koyparakomRRR}
                          prefix={"R"}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>

                    <div className="col-lg-1 col-3"></div>

                    <div className="col-lg-2 col-3"> </div>

                    <div className="col-lg-1 col-3"></div>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FooterOfKas;
